const bussiness = {
  state: {
    info: {},
  },
  mutations: {
    setBussinessInfo(state, info) {
      state.info = info;
    },
  },
};

export default bussiness;
